import { Checkbox } from "@mui/material";

export type TruxSimpleCheckboxFieldProps<T> = {
  value: boolean,
  onChange: VoidFunction,
  size?: "medium" | "small"
}

export default function TruxSimpleCheckboxField<T>({ value, size, onChange }: TruxSimpleCheckboxFieldProps<T>) {
  return <Checkbox size={size || "small"} checked={value} onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    onChange();
  }} />
}